// Fiche produit Maison Murmur : galerie, calcul de surface (m² arrondis au supérieur), visualisation.
(function () {
  var root = document.querySelector('[data-mm-product]');
  if (!root) return;

  var main = root.querySelector('[data-mm-main]');
  var thumbs = root.querySelectorAll('[data-mm-thumb]');
  var textureOpen = root.querySelector('[data-mm-texture-open]');
  var textureBack = root.querySelector('[data-mm-texture-back]');
  var textureCaption = root.querySelector('[data-mm-texture-caption]');
  var textureThumb = root.querySelector('[data-mm-texture="true"]');
  var lastPhoto = thumbs[0];
  var galleryTitle = root.querySelector('[data-mm-gallery-title]');
  var galleryDialog = root.querySelector('[data-mm-gallery-dialog]');

  function showImage(btn) {
    if (!main || !btn) return;
    var isTexture = btn.dataset.mmTexture === 'true';
    if (!isTexture) lastPhoto = btn;
    main.removeAttribute('srcset');
    main.src = btn.dataset.mmThumb;
    var thumbnailImage = btn.querySelector('img');
    if (thumbnailImage) main.alt = thumbnailImage.alt;
    else main.alt = btn.textContent.trim() + ' — ' + root.querySelector('h1').textContent;
    main.parentElement.classList.toggle('is-room', btn.dataset.mmView === 'room');
    if (galleryTitle) galleryTitle.textContent = isTexture ? (previewPaper ? previewPaper.dataset.mmPaperLabel : (root.querySelector('.mm-paper.is-active .mm-paper__name') || btn).textContent) : root.querySelector('h1').textContent;
    main.parentElement.classList.toggle('is-texture', isTexture);
    if (textureOpen) textureOpen.hidden = isTexture || btn !== thumbs[0];
    if (textureBack) textureBack.hidden = !isTexture;
    if (textureCaption) textureCaption.hidden = !isTexture;
    thumbs.forEach(function (b) {
      b.classList.toggle('is-active', b === btn);
      b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
    });
  }
  thumbs.forEach(function (btn, i) {
    btn.classList.toggle('is-active', i === 0);
    btn.setAttribute('aria-pressed', i === 0 ? 'true' : 'false');
    btn.addEventListener('click', function () { showImage(btn); });
  });
  if (textureOpen && textureThumb) textureOpen.addEventListener('click', function () { showImage(textureThumb); });
  if (textureBack) textureBack.addEventListener('click', function () { showImage(lastPhoto); });
  var galleryKey = 'mm-gallery-view-' + location.pathname.replace(/-(intisse-velours|intisse-recycle|special-pieces-d-eau|lin-naturel)\/?$/, '');
  if (root.querySelector('[data-mm-view]')) {
    var savedView;
    try { savedView = sessionStorage.getItem(galleryKey); } catch (e) {}
    var selectedView = Array.from(thumbs).find(function (b) { return b.dataset.mmView === savedView; });
    showImage(selectedView || thumbs[0]);
    thumbs.forEach(function (b) { b.addEventListener('click', function () {
      if (b.dataset.mmView) try { sessionStorage.setItem(galleryKey, b.dataset.mmView); } catch (e) {}
    }); });
  }
  if (galleryDialog) {
    var detailImage = galleryDialog.querySelector('img');
    var detailPane = galleryDialog.querySelector('.mm-gallery-dialog-image');
    var detailControls = galleryDialog.querySelector('[data-mm-detail-controls]');
    var detailMinus = galleryDialog.querySelector('[data-mm-detail-minus]');
    var detailPlus = galleryDialog.querySelector('[data-mm-detail-plus]');
    var detailLevel = galleryDialog.querySelector('[data-mm-detail-level]');
    var detailTitle = galleryDialog.querySelector('[data-mm-detail-title]');
    var detailScale = 1;
    var detailDrag = null;
    var detailAnchor = null;

    function setDetailScale(next, reset, anchor) {
      if (!galleryDialog.open || !galleryDialog.classList.contains('is-texture')) return;
      var oldWidth = detailImage.offsetWidth || detailPane.clientWidth;
      var oldHeight = detailImage.offsetHeight || oldWidth;
      var x = anchor ? anchor.x : reset ? 0.35 : (detailPane.scrollLeft + detailPane.clientWidth / 2) / oldWidth;
      var y = anchor ? anchor.y : reset ? 0.45 : (detailPane.scrollTop + detailPane.clientHeight / 2) / oldHeight;
      detailScale = Math.max(1, Math.min(4, next));
      detailImage.style.width = (detailPane.clientWidth * detailScale) + 'px';
      detailLevel.textContent = detailScale + '×';
      detailMinus.disabled = detailScale === 1;
      detailPlus.disabled = detailScale === 4;
      detailPane.scrollLeft = x * detailImage.offsetWidth - detailPane.clientWidth / 2;
      detailPane.scrollTop = y * detailImage.offsetHeight - detailPane.clientHeight / 2;
    }

    root.querySelector('[data-mm-gallery-zoom]').addEventListener('click', function () {
      var texture = main.parentElement.classList.contains('is-texture');
      galleryDialog.classList.toggle('is-texture', texture);
      if (detailControls) detailControls.hidden = !texture;
      if (detailTitle) detailTitle.textContent = galleryTitle ? galleryTitle.textContent : '';
      detailImage.style.width = '';
      detailImage.src = main.src;
      detailImage.alt = main.alt;
      var original = galleryDialog.querySelector('[data-mm-gallery-original]');
      original.href = main.src; original.hidden = !texture;
      syncDialogPapers();
      detailAnchor = null;
      galleryDialog.showModal();
      detailPane.scrollTop = 0; detailPane.scrollLeft = 0;
      if (texture && detailControls) {
        detailScale = window.matchMedia('(max-width: 749px)').matches ? 3 : 2;
        setDetailScale(detailScale, true);
      }
    });
    detailImage.addEventListener('load', function () {
      if (detailControls && galleryDialog.open) {
        setDetailScale(detailScale, !detailAnchor, detailAnchor);
        detailAnchor = null;
      }
    });
    if (detailControls) {
      detailMinus.addEventListener('click', function () { setDetailScale(detailScale - 1, false); });
      detailPlus.addEventListener('click', function () { setDetailScale(detailScale + 1, false); });
      detailPane.addEventListener('pointerdown', function (event) {
        if (event.pointerType !== 'mouse' || event.button !== 0 || !galleryDialog.classList.contains('is-texture')) return;
        detailDrag = { x: event.clientX, y: event.clientY, left: detailPane.scrollLeft, top: detailPane.scrollTop };
        detailPane.setPointerCapture(event.pointerId);
        detailPane.classList.add('is-dragging');
        event.preventDefault();
      });
      detailPane.addEventListener('pointermove', function (event) {
        if (!detailDrag) return;
        detailPane.scrollLeft = detailDrag.left - (event.clientX - detailDrag.x);
        detailPane.scrollTop = detailDrag.top - (event.clientY - detailDrag.y);
      });
      function stopDetailDrag() { detailDrag = null; detailPane.classList.remove('is-dragging'); }
      detailPane.addEventListener('pointerup', stopDetailDrag);
      detailPane.addEventListener('pointercancel', stopDetailDrag);
      detailPane.addEventListener('lostpointercapture', stopDetailDrag);
      galleryDialog.addEventListener('close', stopDetailDrag);
    }
    root.querySelector('[data-mm-gallery-close]').addEventListener('click', function () { galleryDialog.close(); });
  }


  // Un clic compare les papiers. Seule la confirmation change le produit Shopify.
  var paperLinks = Array.from(root.querySelectorAll('[data-mm-paper-choices] .mm-paper[href]'));
  var committedPaper = paperLinks.find(function (link) { return link.classList.contains('is-active'); });
  var previewPaper = committedPaper;
  var paperRequest = 0;
  var paperImages = new Map();
  var paperLoading = false;
  var PAPER_COMMIT_KEY = 'mm-paper-commit';
  var paperDecision = root.querySelector('[data-mm-paper-decision]');
  var paperPending = root.querySelector('[data-mm-paper-pending]');
  var dialogPapers = root.querySelector('[data-mm-dialog-papers]');
  var paperError = root.querySelector('[data-mm-paper-error]');

  function paperPrice(link) {
    var price = link.querySelector('.mm-paper__price');
    return price ? price.textContent.trim() : '';
  }
  function loadPaper(link) {
    var src = link.dataset.mmPaperImage;
    if (!paperImages.has(src)) {
      var promise = new Promise(function (resolve, reject) {
        var img = new Image();
        img.onload = function () { resolve(src); };
        img.onerror = reject;
        img.src = src;
      });
      paperImages.set(src, promise);
      promise.catch(function () { paperImages.delete(src); });
    }
    return paperImages.get(src);
  }
  function setPaperLoading(value) {
    paperLoading = value;
    root.querySelectorAll('[data-mm-paper-apply]').forEach(function (button) { button.disabled = value; });
    if (main) main.parentElement.setAttribute('aria-busy', value ? 'true' : 'false');
    if (dialogPapers) dialogPapers.setAttribute('aria-busy', value ? 'true' : 'false');
  }
  function updatePaperChoices() {
    if (!previewPaper) return;
    var label = previewPaper.dataset.mmPaperLabel;
    paperLinks.forEach(function (link) {
      link.classList.toggle('is-preview', link === previewPaper);
      link.setAttribute('aria-pressed', link === previewPaper ? 'true' : 'false');
    });
    root.querySelectorAll('[data-mm-paper-index]').forEach(function (button) {
      button.setAttribute('aria-pressed', paperLinks[Number(button.dataset.mmPaperIndex)] === previewPaper ? 'true' : 'false');
    });
    var description = root.querySelector('[data-mm-paper-preview]');
    if (description) description.textContent = label + ' · ' + previewPaper.dataset.mmPaperBrief;
    var pending = previewPaper !== committedPaper;
    root.classList.toggle('mm-paper-pending', pending);
    if (paperPending) {
      paperPending.hidden = !pending;
      paperPending.querySelector('[data-mm-paper-pending-name]').textContent = label + ' · ' + paperPrice(previewPaper);
    }
    root.querySelectorAll('[data-mm-paper-apply]').forEach(function (button) {
      button.setAttribute('aria-label', 'Choisir ce papier : ' + label);
    });
  }
  function syncDialogPapers() {
    if (dialogPapers) dialogPapers.hidden = !galleryDialog.classList.contains('is-texture');
  }
  function selectPaper(link) {
    if (!link) return;
    var request = ++paperRequest;
    setPaperLoading(true);
    if (paperError) paperError.hidden = true;
    loadPaper(link).then(function (src) {
      if (request !== paperRequest) return;
      previewPaper = link;
      updatePaperChoices();
      textureThumb.dataset.mmThumb = src;
      showImage(textureThumb);
      main.alt = link.dataset.mmPaperLabel + ' — ' + root.querySelector('h1').textContent;
      try { sessionStorage.setItem(galleryKey, 'texture'); } catch (e) {}
      if (galleryDialog && galleryDialog.open) {
        var wasTexture = galleryDialog.classList.contains('is-texture');
        detailAnchor = wasTexture ? {
          x: (detailPane.scrollLeft + detailPane.clientWidth / 2) / (detailImage.offsetWidth || 1),
          y: (detailPane.scrollTop + detailPane.clientHeight / 2) / (detailImage.offsetHeight || 1)
        } : {x:0.35, y:0.45};
        galleryDialog.classList.add('is-texture');
        detailControls.hidden = false;
        if (!wasTexture) detailScale = window.matchMedia('(max-width:749px)').matches ? 3 : 2;
        detailImage.src = src;
        detailImage.alt = main.alt;
        detailTitle.textContent = link.dataset.mmPaperLabel;
        galleryDialog.querySelector('[data-mm-gallery-original]').href = src;
        syncDialogPapers();
        setDetailScale(detailScale, false, detailAnchor);
      }
      setPaperLoading(false);
    }).catch(function () {
      if (request !== paperRequest) return;
      setPaperLoading(false);
      if (paperError) { paperError.textContent = 'Le gros plan n’a pas chargé. Réessayez de toucher ce papier.'; paperError.hidden = false; }
    });
  }
  function configTarget() { return root.querySelector('[data-mm-guide]') || root.querySelector('.mm-app-block'); }
  function applyPaper(event) {
    if (event) { event.preventDefault(); event.stopPropagation(); }
    if (!previewPaper || paperLoading) return;
    if (previewPaper === committedPaper) {
      if (galleryDialog && galleryDialog.open) galleryDialog.close();
      root.classList.remove('mm-paper-expanded');
      var target = configTarget();
      if (target) target.scrollIntoView({block:'start', behavior:'smooth'});
      return;
    }
    var url = new URL(previewPaper.href, location.href);
    var inputs = root.querySelectorAll('.mm-app-block input[type="number"]');
    if (inputs.length >= 2 && Number(inputs[0].value) > 0 && Number(inputs[1].value) > 0) {
      url.searchParams.set('mm_w', inputs[0].value);
      url.searchParams.set('mm_h', inputs[1].value);
      var margin = root.querySelector('[data-pwp-allowance]');
      url.searchParams.set('mm_marge', margin && margin.checked ? '1' : '0');
    }
    try { sessionStorage.setItem(PAPER_COMMIT_KEY, JSON.stringify({path:url.pathname,time:Date.now()})); } catch (e) {}
    root.querySelectorAll('[data-mm-paper-apply]').forEach(function (button) { button.disabled = true; });
    location.assign(url.href);
  }
  if (committedPaper && textureThumb && paperDecision) {
    paperDecision.hidden = false;
    // Sur ordinateur, comparer à côté de la photo ; sur mobile, sous la photo.
    var comparison = root.querySelector('[data-mm-paper-comparison]');
    var comparisonHome = document.createComment('mm-paper-comparison-home');
    comparison.before(comparisonHome);
    var desktopComparison = window.matchMedia('(min-width:900px)');
    function placePaperChoices() {
      var buyTitle = root.querySelector('.mm-buy h1');
      if (desktopComparison.matches && buyTitle) buyTitle.after(comparison);
      else comparisonHome.after(comparison);
    }
    placePaperChoices();
    desktopComparison.addEventListener('change', placePaperChoices);
    paperLinks.forEach(function (link, index) {
      link.setAttribute('role', 'button');
      link.removeAttribute('aria-current');
      link.addEventListener('click', function (event) {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault(); event.stopPropagation(); selectPaper(link);
      });
      link.addEventListener('keydown', function (event) {
        if (event.key === ' ') { event.preventDefault(); selectPaper(link); }
      });
      function warmPaper() { loadPaper(link).catch(function () {}); }
      link.addEventListener('pointerenter', warmPaper, {once:true});
      link.addEventListener('focus', warmPaper, {once:true});
      link.addEventListener('pointerdown', warmPaper, {once:true});
    });
    if (dialogPapers) {
      var choices = document.createElement('div');
      choices.className = 'mm-dialog-papers__choices';
      choices.setAttribute('role', 'group'); choices.setAttribute('aria-label', 'Comparer les papiers en gros plan');
      paperLinks.forEach(function (link, index) {
        var button = document.createElement('button');
        button.type = 'button'; button.className = 'mm-dialog-paper';
        button.dataset.mmPaperIndex = index;
        button.append(document.createTextNode(link.dataset.mmPaperLabel));
        var price = document.createElement('small'); price.textContent = paperPrice(link); button.append(price);
        button.addEventListener('click', function () { selectPaper(link); });
        choices.append(button);
      });
      dialogPapers.append(choices);
      var choose = document.createElement('button');
      choose.type = 'button'; choose.className = 'mm-btn'; choose.dataset.mmPaperApply = ''; choose.textContent = 'Choisir ce papier';
      dialogPapers.append(choose);
    }
    root.querySelectorAll('[data-mm-paper-apply]').forEach(function (button) { button.addEventListener('click', applyPaper); });
    var jump = root.querySelector('.mm-config-jump');
    if (jump) jump.addEventListener('click', function (event) {
      if (previewPaper !== committedPaper || paperLoading) applyPaper(event);
    });
    var keep = root.querySelector('[data-mm-paper-keep]');
    if (keep) keep.addEventListener('click', function () { selectPaper(committedPaper); });
    updatePaperChoices();
    // Précharger uniquement les gros plans quand leurs choix entrent dans l'écran.
    if ('IntersectionObserver' in window) {
      var paperObserver = new IntersectionObserver(function (entries) {
        if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
        paperLinks.forEach(function (link) { loadPaper(link).catch(function () {}); });
        paperObserver.disconnect();
      }, {rootMargin:'100px'});
      paperObserver.observe(paperDecision);
    }
    try {
      var paperCommit = JSON.parse(sessionStorage.getItem(PAPER_COMMIT_KEY) || 'null');
      if (paperCommit && paperCommit.path === location.pathname && Date.now() - paperCommit.time < 30000) {
        sessionStorage.removeItem(PAPER_COMMIT_KEY);
        var jumpToConfig = function () {
          var target = configTarget();
          if (target) target.scrollIntoView({block:'start',behavior:'instant'});
        };
        if (document.readyState === 'complete') requestAnimationFrame(jumpToConfig);
        else window.addEventListener('load', jumpToConfig, {once:true});
      }
    } catch (e) {}
  }

  var room = root.querySelector('[data-mm-room]');
  var openRoom = root.querySelector('[data-mm-room-open]');
  if (room && openRoom) {
    openRoom.addEventListener('click', function () {
      // L'image est en chargement différé tant que la fenêtre est fermée : on la force à l'ouverture.
      var img = room.querySelector('img');
      if (img) img.loading = 'eager';
      room.showModal();
    });
    root.querySelector('[data-mm-room-close]').addEventListener('click', function () { room.close(); });
  }

  var euro = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' });

  // Fresques Contrado : les menus (papier, dimensions) désignent une variante à prix fixe.
  var variantsEl = root.querySelector('[data-mm-variants]');
  if (variantsEl) {
    var variants = JSON.parse(variantsEl.textContent);
    var selects = root.querySelectorAll('[data-mm-option]');
    var idInput = root.querySelector('[data-mm-variant-id]');
    var priceEl = root.querySelector('[data-mm-price]');
    var perM2El = root.querySelector('[data-mm-price-m2]');
    var custom = root.querySelector('[data-mm-custom]');
    var buy = root.querySelector('[data-mm-submit]');

    var syncVariant = function () {
      var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
      var variant = variants.find(function (v) {
        return v.options.every(function (value, i) { return value === chosen[i]; });
      });
      buy.disabled = !variant || !variant.available;
      if (!variant) {
        priceEl.textContent = 'Combinaison indisponible';
        perM2El.textContent = '';
        return;
      }
      idInput.value = variant.id;
      priceEl.textContent = euro.format(variant.price / 100);

      // Dimensions standard en pouces (ex. 141 x 96") : on affiche l'équivalent au m².
      var size = chosen.join(' ').match(/(\d+(?:\.\d+)?)\s*x\s*(\d+(?:\.\d+)?)"/);
      if (size) {
        var m2 = (size[1] * 2.54 / 100) * (size[2] * 2.54 / 100);
        perM2El.textContent = 'soit ' + euro.format(variant.price / 100 / m2) + ' / m² (' + m2.toFixed(1).replace('.', ',') + ' m²)';
      } else {
        perM2El.textContent = '';
      }

      // « Custom Size » : le client saisit ses dimensions, transmises avec la commande.
      var isCustom = chosen.some(function (value) { return /custom size/i.test(value); });
      custom.hidden = !isCustom;
      custom.querySelectorAll('input').forEach(function (input) { input.disabled = !isCustom; });
    };

    selects.forEach(function (s) { s.addEventListener('change', syncVariant); });
    syncVariant();
    return;
  }

  var w = root.querySelector('[data-mm-w]');
  var h = root.querySelector('[data-mm-h]');
  if (!w || !h) return;
  var qty = root.querySelector('[data-mm-qty]');
  var areaInput = root.querySelector('[data-mm-area-input]');
  var result = root.querySelector('[data-mm-result]');
  var submit = root.querySelector('[data-mm-submit]');

  function update() {
    var picked = root.querySelector('input[name="id"]:checked');
    var pricePerM2 = picked ? Number(picked.dataset.price) / 100 : 0;
    var width = Number(w.value);
    var height = Number(h.value);
    var valid = w.checkValidity() && h.checkValidity() && width > 0 && height > 0;
    if (!valid) {
      submit.disabled = true;
      result.textContent = 'Saisissez vos dimensions pour obtenir votre prix exact.';
      return;
    }
    var area = (width * height) / 10000;
    var billed = Math.max(1, Math.ceil(area));
    qty.value = billed;
    areaInput.value = area.toFixed(2).replace('.', ',');
    submit.disabled = false;
    result.innerHTML = 'Surface : <strong>' + area.toFixed(2).replace('.', ',') + ' m²</strong> — facturée ' + billed +
      ' m² (arrondi au m² supérieur)<br>Votre fresque : <strong class="mm-measure__total">' + euro.format(billed * pricePerM2) + '</strong>';
  }

  root.addEventListener('input', update);
  root.addEventListener('change', update);
  update();
})();

/* Maison Murmur : ambiances automatiques et geste horizontal, sans commandes visibles. */
(function () {
  if (window.mmRoomSlides) return;
  window.mmRoomSlides = true;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const instances = new Set(), visible = new Set();
  const css=document.createElement('style');
  css.textContent=`.mm-product--visual .mm-gallery__main.mm-gallery-v2{aspect-ratio:4/3;position:relative}.mm-product--visual .mm-gallery__main.mm-gallery-v2>[data-mm-main]{display:block;width:100%!important;height:100%!important;max-height:none!important;object-fit:cover!important}.mm-product--visual .mm-gallery-v2>.mm-room-fade{position:absolute!important;inset:0!important;width:100%!important;height:100%!important;max-height:none!important;object-fit:cover!important;pointer-events:none;z-index:1;filter:none!important}.mm-hover-card .card-gallery{aspect-ratio:1!important;--gallery-aspect-ratio:1!important}.mm-hover-card .mm-card-slideshow-image{object-fit:cover!important;aspect-ratio:1}.mm-card-slideshow-image{display:block!important;width:100%!important;height:100%!important;aspect-ratio:4/3;object-fit:contain!important;background:white}.mm-swipe-surface{touch-action:pan-y;user-select:none;-webkit-user-select:none}.mm-swipe-surface img{-webkit-user-drag:none}.mm-swipe-surface:focus-visible{outline:2px solid #a15d49;outline-offset:3px}`;
  document.head.append(css);
  function chooseCards(candidates,height){
    const list=candidates.filter(x=>x.rect.bottom>0&&x.rect.top<height).sort((a,b)=>Math.abs((a.rect.top+a.rect.bottom)/2-height/2)-Math.abs((b.rect.top+b.rect.bottom)/2-height/2));
    if(!list.length)return[];
    const rowTop=list[0].rect.top;
    return list.filter(x=>Math.abs(x.rect.top-rowTop)<30).sort((a,b)=>a.rect.left-b.rect.left).slice(0,2).map(x=>x.instance);
  }
  function activeInstances(){
    const all=[...visible].filter(i=>i.el.isConnected);
    const cards=chooseCards(all.filter(i=>i.card).map(i=>({instance:i,rect:i.image.getBoundingClientRect()})),innerHeight);
    return new Set([...cards,...all.filter(i=>!i.card)]);
  }
  const io=new IntersectionObserver(entries=>entries.forEach(e=>{
    const i=[...instances].find(v=>v.image===e.target);if(!i)return;
    if(e.isIntersecting&&e.intersectionRatio>.25)visible.add(i);else{visible.delete(i);i.last=Date.now();}
  }),{threshold:[0,.25,.5,1]});
  function setup(el){
    if(el.dataset.mmSlidesReady)return;
    let slides;try{slides=JSON.parse(el.dataset.mmRoomSlides);}catch{return;}
    if(!Array.isArray(slides)||slides.length<3)return;
    const card=el.matches('.product-grid__item,[data-mm-card]');
    let image=card?el.querySelector('.card-gallery img,.slide-picture'):el.querySelector('[data-mm-main]');
    if(!image)return;
    if(card){const link=el.querySelector('.card-gallery [ref="cardGalleryLink"]');if(link){const replacement=document.createElement('img');replacement.className='mm-card-slideshow-image';replacement.width=1448;replacement.height=1086;replacement.loading='lazy';replacement.src=slides[0].src;replacement.alt=slides[0].alt;link.replaceChildren(replacement);image=replacement;}}
    el.dataset.mmSlidesReady='true';
    if(card){
      el.classList.add('mm-hover-card');let hoverVersion=0;const motif=slides.length-1;
      image.loading='lazy';image.removeAttribute('srcset');image.src=slides[motif].src;image.alt=slides[motif].alt;el.dataset.mmSlideIndex=String(motif);
      function showHover(index){const version=++hoverVersion;const preload=new Image();preload.src=slides[index].src;preload.decode().then(()=>{if(version!==hoverVersion)return;image.src=slides[index].src;image.alt=slides[index].alt;el.dataset.mmSlideIndex=String(index);}).catch(()=>{});}
      el.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse')showHover(0);});
      el.addEventListener('pointerleave',e=>{if(e.pointerType==='mouse')showHover(motif);});
      el.addEventListener('focusin',()=>showHover(0));el.addEventListener('focusout',e=>{if(!el.contains(e.relatedTarget))showHover(motif);});
      return;
    }
    const surface=card?el.querySelector('.card-gallery,.slide-frame'):image.parentElement;
    surface.classList.add('mm-swipe-surface');surface.tabIndex=0;surface.setAttribute('role','group');surface.setAttribute('aria-label','Photos de la fresque. Faites glisser ou utilisez les flèches du clavier.');
    image.draggable=false;
    const i={el,image,card,slides,index:0,last:Date.now(),busy:false,gesture:null,lastSwipe:0};instances.add(i);io.observe(image);
    const roomButton=el.querySelector('[data-mm-view="room"]');
    const roomActive=()=>card||!roomButton||roomButton.getAttribute('aria-pressed')==='true';
    i.allowed=()=>roomActive()&&!reduced.matches&&!i.gesture&&!surface.matches(':focus-visible')&&!el.querySelector('dialog[open]');
    i.show=async function(index){
      if(i.busy)return;i.busy=true;const target=(index+slides.length)%slides.length,s=slides[target];
      const preload=new Image();preload.src=s.src;
      try{await preload.decode();}catch{i.busy=false;i.last=Date.now();return;}
      if(!roomActive()){i.busy=false;return;}
      const outgoing=!reduced.matches&&image.complete?image.cloneNode(false):null;
      surface.querySelectorAll('.mm-room-fade').forEach(n=>n.remove());
      if(outgoing){outgoing.removeAttribute('data-mm-main');outgoing.removeAttribute('id');outgoing.removeAttribute('srcset');outgoing.className='mm-room-fade';outgoing.alt='';outgoing.setAttribute('aria-hidden','true');surface.append(outgoing);}
      i.index=target;image.removeAttribute('srcset');image.src=s.src;image.alt=s.alt||'Fresque dans une pièce';
      el.dataset.mmSlideIndex=String(target);if(roomButton)roomButton.dataset.mmThumb=s.src;
      i.last=Date.now();
      if(outgoing){const fade=outgoing.animate([{opacity:1},{opacity:0}],{duration:650,easing:'ease-in-out',fill:'forwards'});fade.finished.finally(()=>{outgoing.remove();i.busy=false;});}else{i.busy=false;}
    };
    surface.addEventListener('pointerdown',e=>{if(e.isPrimary&&(e.pointerType==='touch'||e.pointerType==='pen'))i.gesture={x:e.clientX,y:e.clientY,id:e.pointerId};});
    surface.addEventListener('pointerup',e=>{
      const start=i.gesture;if(!start||start.id!==e.pointerId)return;i.gesture=null;
      const dx=e.clientX-start.x,dy=e.clientY-start.y;i.last=Date.now();
      if(Math.abs(dx)>35&&Math.abs(dx)>Math.abs(dy)*1.3&&roomActive()){e.preventDefault();i.lastSwipe=Date.now();i.show(i.index+(dx<0?1:-1));}
    });
    surface.addEventListener('pointercancel',()=>{i.gesture=null;i.last=Date.now();});
    surface.addEventListener('click',e=>{if(Date.now()-i.lastSwipe<650){e.preventDefault();e.stopImmediatePropagation();}},true);
    surface.addEventListener('keydown',e=>{if((e.key==='ArrowLeft'||e.key==='ArrowRight')&&roomActive()){e.preventDefault();i.show(i.index+(e.key==='ArrowRight'?1:-1));}});
    if(roomButton)new MutationObserver(()=>{i.last=Date.now();surface.querySelectorAll('.mm-room-fade').forEach(n=>n.remove());}).observe(roomButton,{attributes:true,attributeFilter:['aria-pressed']});
    el.dataset.mmSlideIndex='0';
    if(card){image.loading='lazy';image.removeAttribute('srcset');image.src=slides[0].src;image.alt=slides[0].alt||'Fresque dans une pièce';}
  }
  function scan(){document.querySelectorAll('[data-mm-room-slides]').forEach(setup);}
  scan();new MutationObserver(scan).observe(document.body,{childList:true,subtree:true});
  setInterval(()=>{
    if(document.hidden)return;const selected=activeInstances(),now=Date.now();
    instances.forEach(i=>{if(!i.el.isConnected){instances.delete(i);visible.delete(i);io.unobserve(i.image);return;}
      if(!selected.has(i)||!i.allowed()){i.last=now;return;}if(now-i.last>=3000)i.show(i.index+1);
    });
  },250);
  document.addEventListener('visibilitychange',()=>instances.forEach(i=>i.last=Date.now()));
})();
